const consentKey = 'cookieConsentGiven';

export default {
    grantConsent() {
        localStorage.setItem(consentKey, '1');
    },

    revokeConsent() {
        localStorage.removeItem(consentKey);
        location.reload();
    },

    hasConsentBeenGiven() {
        return localStorage.getItem(consentKey);
    },
};
